import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const SearchResultsLoader = () => (
  <Box
    data-testid='search-results-loader'
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    }}
  >
    <CircularProgress
      sx={{
        '& .MuiCircularProgress-svg': {
          height: 'auto',
          width: 'auto',
        },
      }}
    />
  </Box>
);

export default React.memo(SearchResultsLoader);
